export const isValidUrl = (url: string): boolean => {
  // Return false for empty or undefined URLs
  if (!url || url.trim() === '') {
    return false;
  }

  try {
    const urlObj = new URL(url);

    // Check if URL has a valid protocol (http or https)
    if (!urlObj.protocol.match(/^https?:$/)) {
      return false;
    }

    // Check if URL has a valid hostname
    if (!urlObj.hostname || urlObj.hostname === '') {
      return false;
    }

    const pathname = urlObj.pathname;
    if (pathname === '/' || pathname === '') {
      return false;
    }

    return true;
  } catch (_) {
    return false;
  }
};

// Async function to check if URL actually exists (not 404)
export const checkUrlExists = async (url: string): Promise<boolean> => {
  if (!isValidUrl(url)) {
    return false;
  }

  try {
    const response = await fetch(url, {
      method: 'HEAD',
      redirect: 'follow',
    });

    return response.ok || (response.status >= 300 && response.status < 400);
  } catch (error) {
    console.error('Error checking URL existence:', url, error);
    return false;
  }
};
